import axios from "axios"
import Link from "next/link"
import { useState, useRef, useEffect } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import validator from "validator"
import database from "../database.mjs"
import { NextSeo } from "next-seo"

export async function getServerSideProps({ query }) {
  if (query?.id && query?.type === "sales") {
    const property = database.prepare("select address, area from properties_for_sale where id = ? limit 1").get(query?.id)

    if (property) {
      return {
        props: {
          _address: `${property?.address}, ${property?.area}`,
          id: query?.id,
          type: "sales",
        },
      }
    }
  }

  if (query?.id && query.type === "lettings") {
    const property = database.prepare("select address, area from properties_to_let where id = ? limit 1").get(query?.id)

    if (property) {
      return {
        props: {
          _address: `${property?.address}, ${property?.area}`,
          id: query?.id,
          type: "lettings",
        },
      }
    }
  }

  if (!query?.id && query?.type === "lettings") {
    let properties = database
      .prepare("select id, address, area, price, beds, audience from properties_to_let ORDER BY price DESC")
      .all()

    properties = [
      ...properties.filter(property => property.audience !== "student"),
      ...properties.filter(property => property.audience === "student"),
    ]

    return {
      props: {
        properties,
        type: "lettings",
      },
    }
  }

  return {
    redirect: {
      destination: "/",
      permanent: false,
    },
  }
}

function Viewing({ _address, id, type, properties }) {
  const recaptchaRef = useRef()

  const [hideForm, setHideForm] = useState(false)

  const [isLoading, setIsLoading] = useState(false)

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [address, setAddress] = useState(_address || "")
  const [availablity, setAvailablity] = useState("")

  const [showNameError, setShowNameError] = useState(false)
  const [showEmailError, setShowEmailError] = useState(false)
  const [showPhoneError, setShowPhoneError] = useState(false)
  const [showAddressError, setShowAddressError] = useState(false)
  const [showAvailablityError, setShowAvailablityError] = useState(false)

  const [propertyId, setPropertyId] = useState("id")

  return (
    <div className="relative w-screen h-screen bg-neutral-900">
      <NextSeo title="Arrange a Viewing" noindex />
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LdLXuQkAAAAAEgcXLcZOgGOJN2lzzo16-Mp0dJ1" />
      <video
        autoPlay
        className="object-cover w-screen h-screen"
        loop
        muted
        playsInline
        src="/drone-2.mp4"
        poster="/images/drone-video-poster.webp"
      />
      <div className="absolute top-0 left-0 flex flex-col w-full h-full max-w-screen-md px-4 overflow-scroll text-white bg-opacity-75 no-scrollbar bg-neutral-900 backdrop-blur-sm sm:px-16">
        <div className="py-4 m-auto sm:max-w-lg sm:mx-auto">
          <div className="mt-0">
            <Link href="/">
              <div className="inline-block select-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 230 52" className="h-12">
                  <path
                    fill="#fff"
                    d="M26.235 34.235V23.529H13.176v10.706l3.883 3.53v1.294H0v-1.295l3.882-3.529V8.588L0 5.058V3.766h17.059V5.06l-3.883 3.53v11.176h13.06V8.588l-3.883-3.53V3.766H39.41V5.06l-3.882 3.53v25.646l3.882 3.53v1.294H22.235v-1.295l4-3.529zM44.823 18.47l-3.176-2.352v-1.294L53.41 12v15.53c0 1.882.353 3.293.941 4.235.589.823 1.647 1.294 3.059 1.294 1.176 0 2.588-.353 4.118-.941V18.47l-3.177-2.353v-1.294L70.117 12v22.117l4.235 1.648v1.294l-9.294 2.706-3.53-4.706c-.94 1.411-2 2.47-3.411 3.294-1.412.823-2.941 1.176-4.588 1.176-2.706 0-4.824-.823-6.353-2.47-1.647-1.647-2.47-3.883-2.47-6.706V18.47h.117zm52.235 16.706V24c0-3.647-1.294-5.53-3.882-5.53-1.647 0-3.177.471-4.706 1.412v15.294l2.942 2.588v1.295H76.588v-1.294l3.176-2.589v-16.47l-3.411-2.47V14.94L86 11.882l1.647 4.824c1.411-1.53 2.941-2.706 4.47-3.53 1.53-.823 3.177-1.176 5.06-1.176 2.587 0 4.705.823 6.234 2.47 1.529 1.648 2.353 3.883 2.353 6.706v14.118L108.94 38v1.294H94.117V38l2.941-2.824zm26.118-29.411v6.588h7.058v3.764h-7.058v14c0 1.883.353 3.177.941 3.883s1.647 1.059 2.941 1.059c1.412 0 2.824-.118 3.882-.471v1.294c-.47.47-1.176 1.059-2.235 1.647-.941.588-2.117 1.177-3.412 1.53-1.293.352-2.588.588-3.764.588-2.236 0-4-.588-5.294-2-1.294-1.294-1.883-3.177-1.883-5.53v-16h-4.118v-2.47l4.118-.588V7.765l8.824-2zm13.175 29.411V6.471l-3.176-2.353V2.824L144.94 0v35.176l3.176 2.588v1.294h-14.941v-1.294l3.176-2.588zm39.765-9.882h-15.647c.118 2 .471 3.647.942 4.941.471 1.412 1.412 2.47 2.588 3.294 1.177.824 2.941 1.294 5.177 1.294 1.764 0 3.764-.353 5.882-1.176l.823 1.647c-1.176 1.294-2.706 2.235-4.588 3.059-1.882.823-3.882 1.176-6.235 1.176-4.353 0-7.765-1.176-10.236-3.53-2.47-2.352-3.646-5.646-3.646-9.882 0-1.882.352-3.647.941-5.411a11.568 11.568 0 012.823-4.588c1.177-1.294 2.706-2.353 4.471-3.177 1.765-.823 3.647-1.176 5.647-1.176 1.294 0 2.588.117 3.882.47 1.295.353 2.471.941 3.647 1.883 1.059.823 2 2 2.706 3.411.706 1.412 1.059 3.06 1.059 5.059.117.941 0 1.765-.236 2.706zM164.822 16c-.588 0-1.176.235-1.882.588-.706.47-1.176 1.177-1.647 2.235-.47 1.06-.706 2.353-.824 3.765l8.235-1.059c-.116-1.882-.588-3.294-1.176-4.235-.588-.823-1.529-1.294-2.706-1.294zm17.177 36l-2.352-7.647c.235 0 1.059-.118 2.588-.236 1.529-.117 2.823-.352 3.764-.705 1.059-.353 2.001-.824 2.824-1.647.824-.706 1.647-1.648 2.235-2.706l-10.47-22.706-3.176-2.588V12.47h15.647v1.294l-3.177 2.588 5.294 12.941 4.823-12.941-3.176-2.588V12.47h10.823v1.294l-3.411 2.588-9.412 22.823c-1.53 3.648-2.706 6.236-3.647 7.647-.941 1.412-2.117 2.589-3.53 3.412-1.411.824-3.294 1.412-5.647 1.765zm47.882-21.059c0 2.824-1.059 4.941-3.176 6.47-2.118 1.412-5.059 2.236-8.824 2.236-1.294 0-2.588-.118-3.882-.236-1.294-.117-2.941-.588-4.706-1.058v-8.824h1.295l4.117 6.118c.824.235 1.646.47 2.235.47 3.059 0 4.706-.94 4.706-2.705 0-.471-.236-1.06-.706-1.647-.47-.589-1.765-1.412-3.882-2.353-2.236-.941-3.765-1.883-4.706-2.706-.941-.824-1.648-1.647-2.118-2.706-.471-1.059-.706-2.235-.706-3.53 0-2.47.942-4.588 2.941-6.117 2.001-1.53 4.707-2.353 8.236-2.353 2.588 0 4.941.47 7.293 1.53v7.764h-1.293l-3.882-5.53c-2.001 0-3.294.236-3.883.707-.706.47-.941 1.176-.941 2 0 .352.117.705.235 1.058.235.353.471.706.941 1.06.471.352 1.883 1.058 4.353 2.235 2.471 1.176 4.236 2.352 5.059 3.646.824 1.295 1.294 2.706 1.294 4.471z"
                  ></path>
                </svg>
              </div>
            </Link>
          </div>
          <div className="relative">
            <h1
              className={[
                `mt-2 text-3xl font-medium text-white drop-shadow transition-all duration-300`,
                hideForm ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto",
              ].join(" ")}
            >
              Arrange a viewing
            </h1>
            {!hideForm && _address && (
              <div className="pb-8 border-b border-white ">
                <label className="flex border-[1.625px] rounded border-white items-center justify-between flex-1 mt-4">
                  <input
                    disabled
                    id="address"
                    type="text"
                    maxLength={64}
                    className={` hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none block w-full py-3 px-4 bg-transparent rounded-sm drop-shadow focus:outline-none  hover:cursor-not-allowed`}
                    placeholder="Property Address or Property Reference #"
                    value={address}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 mr-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                    />
                  </svg>
                </label>
              </div>
            )}
            {!hideForm && !_address && properties?.length >= 0 && (
              <div className="pb-8 border-b border-white">
                <div className="relative">
                  <select
                    className={`appearance-none relative mt-4 hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none  block w-full py-3 px-4 bg-transparent border-[1.625px] rounded-sm drop-shadow focus:outline-none ${
                      propertyId === "id" ? "text-white text-opacity-75" : "text-white"
                    }`}
                    value={properties.find(({ id }) => id === propertyId)}
                    onChange={event => {
                      setPropertyId(event.target.value)
                    }}
                    defaultValue={"id"}
                  >
                    <option value="id" disabled className="text-black">
                      Property
                    </option>
                    {properties.map((property, index) => (
                      <option key={property?.id || index} value={property.id} className="text-black">
                        {`${property?.address}, ${property?.area} • ${new Intl.NumberFormat("en-gb", {
                          style: "currency",
                          currency: "GBP",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(
                          property?.audience === "professional" ? property?.price : (property?.price * 12) / property?.beds / 52
                        )} ${property?.audience === "student" ? "pppw" : "pcm"}`}
                      </option>
                    ))}
                  </select>
                  <div className="absolute top-0 bottom-0 right-0 flex items-center justify-center pr-3 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            )}
            <div className={[`mt-8 transition-all duration-300`, hideForm ? "opacity-0" : "opacity-100"].join(" ")}>
              <label className="block">
                <input
                  id="name"
                  minLength={2}
                  maxLength={48}
                  onFocus={() => setShowNameError(false)}
                  onChange={e => {
                    const { value } = e.target

                    const re = /^[a-zA-Z\s]*$/

                    if (value === "" || re.test(value)) setName(value)
                  }}
                  className={`hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none  block w-full py-3 px-4 mt-2 bg-transparent border-[1.625px] rounded-sm drop-shadow focus:outline-none ${
                    showNameError
                      ? "border-red-500 placeholder:text-red-500 hover:bg-red-400"
                      : "border-white placeholder:text-neutral-300 hover:bg-white"
                  }`}
                  placeholder="Name"
                  type="text"
                  value={name}
                />
              </label>
              {/* <p className="mt-8 text-sm">
              You only have to provide either your email address or phone number, however you may choose to share both.
            </p> */}
              {showEmailError && (
                <p className="flex-1 block mt-4 text-sm text-amber-500">How would you like us to contact you?</p>
              )}
              <div className={`flex items-center justify-between gap-x-3 ${showEmailError ? "mt-2" : "mt-4"}`}>
                <label className="flex-1 block">
                  <input
                    id="email"
                    type="email"
                    minLength={6}
                    onChange={e => {
                      const { value } = e.target

                      const newValue = value.trim()
                      setEmail(newValue)
                    }}
                    onFocus={() => {
                      setShowEmailError(false)
                      setShowPhoneError(false)
                    }}
                    maxLength={64}
                    className={`hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none  block w-full py-3 px-4 bg-transparent border-[1.625px] rounded-sm drop-shadow focus:outline-none ${
                      showEmailError
                        ? "border-amber-500 placeholder:text-amber-500 hover:bg-amber-400"
                        : "border-white placeholder:text-neutral-300 hover:bg-white"
                    }`}
                    placeholder="Email Address"
                    value={email}
                  />
                </label>
                <label className="flex-1 block">
                  <input
                    id="phone"
                    type="tel"
                    maxLength={15}
                    onFocus={() => {
                      setShowPhoneError(false)
                      setShowEmailError(false)
                    }}
                    onChange={e => {
                      const { value } = e.target
                      if (phone.includes("+") && value.replace(/[^+]/g, "").length > 1) return

                      const re = /^[\d+]+$/
                      if (value === "" || re.test(value)) setPhone(value)
                    }}
                    className={`hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none  block w-full py-3 px-4 bg-transparent border-[1.625px] rounded-sm drop-shadow focus:outline-none ${
                      showPhoneError
                        ? "border-amber-500 placeholder:text-amber-500 hover:bg-amber-400"
                        : "border-white placeholder:text-neutral-300 hover:bg-white"
                    }`}
                    placeholder="Phone Number"
                    value={phone}
                  />
                </label>
              </div>
              <label className="flex-1 block mt-4">
                <textarea
                  autoComplete="off"
                  id="address"
                  type="text"
                  maxLength={128}
                  onChange={e => {
                    setAvailablity(e.target.value)
                  }}
                  onFocus={() => setShowAvailablityError(false)}
                  className={`resize-none hover:bg-opacity-25 focus:bg-white focus:bg-opacity-25 placeholder:drop-shadow-none  block w-full py-3 px-4 mt-2 bg-transparent border-[1.625px] rounded-sm drop-shadow focus:outline-none ${
                    showAvailablityError
                      ? "border-red-500 placeholder:text-red-500 hover:bg-red-400"
                      : "border-white placeholder:text-neutral-300 hover:bg-white"
                  }`}
                  placeholder="When are you available?"
                  value={availablity}
                />
                <p className="mt-3 text-sm">Our team will contact you to confirm your appointment.</p>
              </label>
              <div className="w-full h-px mt-8 bg-neutral-300"></div>
              <p className="mt-4 text-sm">
                Your data will be handled in accordance with our{" "}
                <Link href="/docs/privacy.pdf" target="_blank">
                  <span className="font-medium hover:cursor-pointer">Privacy Policy</span>
                </Link>
                .
              </p>
              <button
                onClick={async e => {
                  e.preventDefault()

                  let error = false
                  if (validator.isEmpty(name.trim())) {
                    setShowNameError(true)
                    error = true
                  }

                  if (validator.isEmpty(email.trim())) {
                    setShowEmailError(true)
                    error = true
                  }

                  if (validator.isEmpty(phone.trim())) {
                    setShowPhoneError(true)
                    error = true
                  }

                  if (!properties) {
                    if (validator.isEmpty(address.trim())) {
                      setShowAddressError(true)
                      error = true
                    }
                  }

                  if (validator.isEmpty(availablity.trim())) {
                    setShowAvailablityError(true)
                    error = true
                  }

                  if (!propertyId) error = true

                  if (error) return

                  setIsLoading(true)

                  const token = await recaptchaRef.current.executeAsync()

                  await axios.post("/api/viewing", {
                    id: id ? Number.parseInt(id) : Number.parseInt(propertyId),
                    name,
                    email,
                    phone,
                    availablity,
                    token,
                    type,
                  })
                  setIsLoading(false)

                  setHideForm(true)
                }}
                className={`w-full p-4 mt-3 font-medium rounded g-recaptcha hover:cursor-pointer  ${
                  isLoading ? "hover:cursor-wait bg-neutral-300 text-neutral-600" : "bg-white text-neutral-900"
                }`}
                type="submit"
              >
                {isLoading ? "Loading..." : "Arrange my viewing"}
              </button>
            </div>
            <div
              className={[
                `absolute top-0 transition-all duration-300 h-full flex-col justify-center delay-300`,
                hideForm ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none",
              ].join(" ")}
            >
              <h1 className={[`mt-2 text-3xl font-medium text-white drop-shadow transition-all duration-300`].join(" ")}>
                Thank you
              </h1>
              <p className="mt-2 drop-shadow">
                We've received your request and will be in touch to confirm your appointment shortly.
              </p>
              <button
                onClick={e => {
                  e.preventDefault()
                  window.close()
                }}
                className="w-full p-4 mt-6 font-medium bg-white rounded hover:cursor-pointer text-neutral-900"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Viewing

